import script from "./UserMypage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserMypage.vue?vue&type=script&setup=true&lang=js"

import "./UserMypage.vue?vue&type=style&index=0&id=25dfa65c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25dfa65c"]])

export default __exports__